import React from 'react';
import config from '../../config';
import {
    IconSocialMediaYoutube,
    IconSocialMediaInstagram,
    IconSocialMediaTiktok,
    IconSocialMediaFacebook,
    ExternalLink,
} from '../../components';
import css from './Footer.css';

const { siteYoutubePage, siteInstagramPage, siteTikTokPage, siteFacebookPage } = config;

const SocialMediaIcons = () => (
    <>
        <ExternalLink
            key="linkToInstagram"
            href={siteInstagramPage}
            className={css.socialLink}
            title="TikTok"
        >
            <IconSocialMediaInstagram />
        </ExternalLink>

        <ExternalLink
            key="linkToFacebook"
            href={siteFacebookPage}
            className={css.socialLink}
            title="Facebook"
        >
            <IconSocialMediaFacebook />
        </ExternalLink>

        <ExternalLink
            key="linkToTikTok"
            href={siteTikTokPage}
            className={css.socialLink}
            title="Instagram"
        >
            <IconSocialMediaTiktok />
        </ExternalLink>

        <ExternalLink
            key="linkToYoutube"
            href={siteYoutubePage}
            className={css.socialLink}
            title="YouTube"
        >
            <IconSocialMediaYoutube />
        </ExternalLink>
    </>
);

export default SocialMediaIcons;
